import '../styles/Home.css';
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { RiArrowRightCircleFill } from 'react-icons/ri';
import { useApiCall } from '../hooks/useApiCall';

export default function Home() {
  const navigate = useNavigate();
  const apiCall = useApiCall();

  const [banners, setBanners] = useState([]);
  const [bannersLoading, setBannersLoading] = useState(true);

  // Fetch banners on component mount
  useEffect(() => {
    const fetchBanners = async () => {
      setBannersLoading(true);
      try {
        const response = await apiCall('home/banners', 'GET');
        if (response.success && response.data.banners) {
          setBanners(response.data.banners);
        }
      } catch (error) {
        console.error('Error fetching banners:', error);
      } finally {
        setBannersLoading(false);
      }
    };

    fetchBanners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Create URL-friendly slug from category name
  const createSlug = (name) => {
    return name
      .toLowerCase()
      .replace(/[^a-z0-9\s&]/g, '')
      .replace(/\s*&\s*/g, '-and-')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  };

  const handleBannerClick = (banner) => {
    // Check if this is a "New Arrivals" banner (category_id = 0 or is_new_arrivals flag)
    if (banner.is_new_arrivals || banner.category_id === 0) {
      navigate('/products?sort=new');
    } else if (banner.category_id && banner.category_name) {
      const slug = createSlug(banner.category_name);
      navigate(`/products/category/${banner.category_id}/${slug}`);
    } else {
      navigate('/products');
    }
  };

  // Split banners into two groups - insert New Arrivals after 3rd banner
  const firstBanners = banners.slice(0, 3);
  const remainingBanners = banners.slice(3);

  return (
    <div className="home-page">
      
      {bannersLoading ? (
        <div className="home-loading">
          <p>Loading...</p>
        </div>
      ) : (
        <>
          {/* First 3 banners */}
          {firstBanners.map((banner) => {
            const title = banner.title || banner.category_name || 'Explore Our Products';
            const subtitle = banner.subtitle || '';
            const cta = `Explore ${banner.category_name || 'Products'}`;
            
            return (
              <div 
                key={banner.id} 
                className="home-banner"
                style={{ 
                  backgroundImage: banner.image ? `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.6)), url(${banner.image})` : '',
                }}
                onClick={() => handleBannerClick(banner)}
              >
                <div className="home-banner-content">
                  <h2 className="home-banner-title">{title}</h2>
                  {subtitle && <p className="home-banner-subtitle">{subtitle}</p>}
                  <button className="home-banner-cta">
                    {cta}
                    <RiArrowRightCircleFill className="home-banner-arrow" size={24} />
                  </button>
                </div>
              </div>
            );
          })}

          {/* Fixed New Arrivals Banner */}
          <div 
            className="home-banner home-banner-new-arrivals"
            onClick={() => navigate('/products?sort=new')}
          >
            <div className="home-banner-content">
              <span className="home-banner-badge">NEW</span>
              <h2 className="home-banner-title">New Arrivals</h2>
              <p className="home-banner-subtitle">Discover our latest products • Fresh designs just landed</p>
              <button className="home-banner-cta">
                Shop New Arrivals
                <RiArrowRightCircleFill className="home-banner-arrow" size={24} />
              </button>
            </div>
          </div>

          {/* Remaining banners */}
          {remainingBanners.map((banner) => {
            const title = banner.title || banner.category_name || 'Explore Our Products';
            const subtitle = banner.subtitle || '';
            const cta = `Explore ${banner.category_name || 'Products'}`;
            
            return (
              <div 
                key={banner.id} 
                className="home-banner"
                style={{ 
                  backgroundImage: banner.image ? `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.6)), url(${banner.image})` : '',
                }}
                onClick={() => handleBannerClick(banner)}
              >
                <div className="home-banner-content">
                  <h2 className="home-banner-title">{title}</h2>
                  {subtitle && <p className="home-banner-subtitle">{subtitle}</p>}
                  <button className="home-banner-cta">
                    {cta}
                    <RiArrowRightCircleFill className="home-banner-arrow" size={24} />
                  </button>
                </div>
              </div>
            );
          })}

          {banners.length === 0 && (
            <div className="home-no-banners">
              <p>No banners available at the moment.</p>
            </div>
          )}
        </>
      )}

    </div>
  );
}
